var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdflix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 22,
    viewBox: "0 0 107 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.57475 19.1576C4.2281 19.8817 5.63633 19.5413 7.37698 18.5552C5.79352 17.4639 4.56051 15.8887 3.87932 14.0365C2.84935 16.174 2.57916 18.0513 3.57475 19.1576ZM20.1116 5.2395C20.9107 3.63431 21.1563 2.33109 20.5472 1.65029C19.6121 0.607393 17.8552 0.851014 15.805 1.87222C17.549 2.53631 19.0456 3.72108 20.1116 5.2395ZM12.5645 1.27985C13.2129 1.27985 13.8466 1.34827 14.4574 1.47675C17.2722 -0.138482 19.8398 -0.609037 21.266 0.981169C22.183 2.00404 21.867 3.82117 20.7928 5.95034V5.94866L20.7879 5.96036C20.7535 6.02877 20.7191 6.0955 20.6831 6.16559L20.6913 6.18227C18.389 11.37 13.9138 15.7702 8.68532 18.9189L8.33981 19.1392L8.3316 19.1342C5.96382 20.5509 3.92025 21.0164 2.85426 19.8334C1.40837 18.2281 1.91599 15.5567 3.49287 12.6849C3.36351 12.0509 3.29474 11.3967 3.29474 10.726C3.29474 5.50815 7.44409 1.27985 12.5645 1.27985ZM21.4248 7.94269C21.6901 8.82204 21.8342 9.75651 21.8342 10.726C21.8342 15.9421 17.6849 20.1721 12.5645 20.1721C11.6049 20.1721 10.6797 20.0236 9.81027 19.7483C14.9699 16.6179 18.8868 12.7133 21.4232 7.94767L21.4248 7.94269Z",
    fill: "url(#paint0_linear_1670_10374)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8184 21.0442V0.476807H36.9337V2.36323H27.8534V9.75961H36.6315V11.5917H27.8534V19.212H36.9337V21.0442H25.8184ZM39.673 12.7317C39.7939 11.3158 40.2326 10.0604 40.9893 8.96569C41.7505 7.87092 42.6997 7.02273 43.837 6.42106C44.9743 5.81487 46.1454 5.49143 47.3495 5.45069C48.6213 5.45069 49.8077 5.69726 50.9093 6.19033C52.0108 6.68344 52.9061 7.45699 53.5958 8.51106V0.476807H55.6307V21.0442H53.7031V18.1535C52.9867 19.2347 52.1272 20.0422 51.1242 20.576C50.1256 21.1098 48.9034 21.3767 47.4572 21.3767C46.2212 21.3224 44.9967 20.956 43.7833 20.2774C42.5699 19.5943 41.5759 18.6511 40.8013 17.4478C40.0312 16.2445 39.6461 14.8873 39.6461 13.3764C39.6461 13.0959 39.655 12.881 39.673 12.7317ZM41.7617 12.5689C41.7259 12.7544 41.708 13.0326 41.708 13.4035C41.708 14.4078 41.9677 15.3691 42.4871 16.2874C43.0065 17.2057 43.7162 17.9499 44.6161 18.5199C45.5205 19.0899 46.5234 19.384 47.625 19.4021C48.6189 19.4021 49.5841 19.151 50.5198 18.6488C51.4599 18.1467 52.2258 17.4229 52.8165 16.4774C53.4075 15.5274 53.7031 14.4282 53.7031 13.1796C53.7031 12.5101 53.4905 11.7252 53.0653 10.825C52.6444 9.92018 51.9747 9.13758 51.057 8.47711C50.1437 7.81212 48.9997 7.47962 47.625 7.47962C46.8771 7.47962 46.0915 7.64925 45.2676 7.98853C44.4482 8.32329 43.7094 8.8752 43.0512 9.64427C42.3975 10.4088 41.9677 11.3837 41.7617 12.5689ZM58.5982 12.7317C58.7193 11.3158 59.1579 10.0604 59.9148 8.96569C60.676 7.87092 61.6251 7.02273 62.7624 6.42106C63.8998 5.81487 65.0705 5.49143 66.275 5.45069C67.5468 5.45069 68.7332 5.69726 69.8348 6.19033C70.936 6.68344 71.8316 7.45699 72.5209 8.51106V0.476807H74.5562V21.0442H72.6286V18.1535C71.9122 19.2347 71.0523 20.0422 70.0494 20.576C69.0512 21.1098 67.8285 21.3767 66.3823 21.3767C65.1467 21.3224 63.9222 20.956 62.7086 20.2774C61.4954 19.5943 60.5011 18.6511 59.7265 17.4478C58.9567 16.2445 58.5715 14.8873 58.5715 13.3764C58.5715 13.0959 58.5806 12.881 58.5982 12.7317ZM60.687 12.5689C60.6513 12.7544 60.6332 13.0326 60.6332 13.4035C60.6332 14.4078 60.893 15.3691 61.4125 16.2874C61.9316 17.2057 62.6414 17.9499 63.5414 18.5199C64.446 19.0899 65.449 19.384 66.5505 19.4021C67.5444 19.4021 68.5092 19.151 69.4449 18.6488C70.3854 18.1467 71.1509 17.4229 71.742 16.4774C72.3331 15.5274 72.6286 14.4282 72.6286 13.1796C72.6286 12.5101 72.416 11.7252 71.9904 10.825C71.5695 9.92018 70.9002 9.13758 69.9826 8.47711C69.0688 7.81212 67.9248 7.47962 66.5505 7.47962C65.8027 7.47962 65.0167 7.64925 64.1929 7.98853C63.3735 8.32329 62.6347 8.8752 61.9764 9.64427C61.3229 10.4088 60.8929 11.3837 60.687 12.5689Z",
    fill: "url(#paint1_linear_1670_10374)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7988 21.0442V0.476807H88.8342V21.0442H86.7988ZM89.9216 21.0442V5.83751H91.9565V21.0442H89.9216ZM89.9216 4.00536V0.476807H91.9565V4.00536H89.9216ZM93.9301 21.0442L99.0748 13.2882L93.9301 5.83751H96.3478L100.31 11.7071L104.354 5.83751H106.718L101.546 13.3424L106.718 21.0442H104.354L100.31 14.9574L96.3478 21.0442H93.9301Z",
    fill: "url(#paint2_linear_1670_10374)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9384 6.64676C77.8007 1.14511 84.3256 -0.0416881 88.5306 0.525127V2.90576H86.0308C79.0296 2.36161 78.6433 7.89384 78.6433 12.315H84.0984V14.6957L78.6433 14.5665V21.044H76.3698C76.332 18.5122 76.2633 10.9547 76.9384 6.64676Z",
    fill: "url(#paint3_linear_1670_10374)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1670_10374",
    x1: 1.48671,
    y1: -0.933822,
    x2: 25.7845,
    y2: 6.16677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#202020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402681,
    stopColor: "#242424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464673,
    stopColor: "#3C3C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536527,
    stopColor: "#252525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2B2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1670_10374",
    x1: 22.3224,
    y1: -1.22945,
    x2: 74.2956,
    y2: 29.3982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#202020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402681,
    stopColor: "#242424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464673,
    stopColor: "#3C3C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536527,
    stopColor: "#252525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2B2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1670_10374",
    x1: 84.4228,
    y1: -1.22945,
    x2: 112.012,
    y2: 5.56512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#202020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402681,
    stopColor: "#242424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464673,
    stopColor: "#3C3C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536527,
    stopColor: "#252525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2B2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1670_10374",
    x1: 76.0326,
    y1: -0.543247,
    x2: 91.7326,
    y2: 2.25574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#202020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402681,
    stopColor: "#242424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464673,
    stopColor: "#3C3C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536527,
    stopColor: "#252525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2B2B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdflix);
export default __webpack_public_path__ + "static/media/edflix.cc7eee024d57cb9d1b2e5985f36de74b.svg";
export { ForwardRef as ReactComponent };